import { pino } from "pino";
import { setLogger } from "../logger.js";

let installed = false;

export const installPinoLogger = (): void => {
  if (installed) return;
  installed = true;
  const development = process.env["NODE_ENV"] === "development";
  setLogger(
    pino({
      level: process.env["LOG_LEVEL"] ?? "info",
      base: { component: "pinboard" },
      ...(development && {
        transport: {
          target: "pino-pretty",
          options: {
            colorize: true,
            translateTime: "HH:MM:ss Z",
            ignore: "pid,hostname,component",
          },
        },
      }),
    }),
  );
};
